import React, { useEffect } from "react";
import { Box } from "@mui/material";
import AiAgentMap from "../components/AiAgents/AiAgentMap";
import "../css/NewAgentViewerScreen.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { processedDocumentsDetailsAPI } from "../redux/slices/LoadAIAgentsSlice";

function NewAgentViewerScreen() {
  const { slugName } = useSelector((state) => state.CreateAgentSlice);
  const { processedDocumentsDetails } = useSelector((state) => state.LoadAIAgentsSlice);
  const {results} = processedDocumentsDetails

  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  useEffect(() => {
    dispatch(processedDocumentsDetailsAPI(slugName));
  }, [slugName]);

  return (
    <div>
      <div style={{ marginLeft: 40 }} className="nav-title">
        <button
          onClick={() => navigate("/NewAgentViewerScreen")}
          className="back-button"
        >
          <ArrowBack />
        </button>
        <h3>{"Documents"}</h3>
      </div>
      <Box
        style={{ marginTop: 10, margineLeft: 120, marginRight: 120 }}
        className="ai-agent-container"
      >
        <AiAgentMap results={results} />
      </Box>
    </div>
  );
}

export default NewAgentViewerScreen;
